export default __webpack_public_path__ + "static/media/playStory.4b2edae3.png";